import { connect } from 'react-redux'
import qs from 'qs'

import { saveLeadSecretToken } from '../../actions/leadActionCreators'
import { fetchPosition } from '../../actions/positionActionCreators'

const mapStateToProps = (state) => ({})

// `match` and `location` are injected into props by react-router
const mapDispatchToProps = (dispatch, { location, match }) => ({
  loadPosition: () => {
    const parsed = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })
    const positionId = match.params.positionId
    const secretToken = parsed.secret_token

    dispatch(fetchPosition(positionId, secretToken))
      .then(dispatch(saveLeadSecretToken(secretToken)))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)



// WEBPACK FOOTER //
// ./src/components/PositionScene/positionSceneContainer.js